import React, { useEffect, useState } from "react";
import ModalTiny from "react-bootstrap/Modal"  
import ContactForm from "../forms/contact-form"

import "../MarketData/MarketData.scss";
import "./ContactForm.scss";


const Contact = (props) => {
  return (
    <div>
      <ModalTiny backdrop="static" show={props.openForm} onHide={() => { props.setOpenForm(false) }} className="book-a-viewing-modal contact-popup-form">
        <ModalTiny.Header
          closeButton={props.disableClose ? false : true}
          className="contact-close-btn">
          <ModalTiny.Title className="w-100">
            <div className="text-center heading">Contact Us</div>
          </ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section">
          <ContactForm setOpenForm={props.setOpenForm} />
        </ModalTiny.Body>
      </ModalTiny>

    </div>
  )
}

export default Contact
